import React, { useMemo } from "react"
import * as GD from 'data/GlobalDispatch';
import * as Api from "api/api";
import YAML from 'yaml'



import { BaseEditor, createEditor, Descendant, Editor, Transforms } from "slate"
import { Slate, Editable, withReact, ReactEditor } from "slate-react"
import { HistoryEditor, withHistory } from 'slate-history';

import { Box, Button, Divider, Grid, Typography, Stack } from '@mui/material';

import { useParams } from 'react-router-dom';

import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatBoldIcon from '@mui/icons-material/FormatBold';



let fontFamily = 'helvetica'


// type TextTypes = 'paragraph' | 'quote' | 'block-quote' | 'paragraphTitle';
type TextTypes = 'type' | 'field' | 'style' | 'text' | 'align' | 'link' | 'icon';
type CustomElement = { type: TextTypes; children: CustomText[]; styles?: any }
// type CustomText = { text: string; bold?: boolean, italic?: boolean, code?: boolean }
type CustomText = { text: string; field?: string; }

declare module 'slate' {
    interface CustomTypes {
        Editor: BaseEditor & ReactEditor & HistoryEditor
        Element: CustomElement
        Text: CustomText
    }
}

export const macroCopyInsertSlateId = 'LangListener';
export const markSlateId = 'markSlate';
export let slateValue = {};


interface SlateEditorProps {
}

// const isMarkActive = (editor, format) => {
//     const marks = Editor.marks(editor)
//     console.log(`mark is ${ marks }`)
//     console.log(marks)
//     return marks ? marks[format] === true : false
// }

// const toggleMark = (editor, format) => {
//     const isActive = isMarkActive(editor, format)

//     if (isActive) {
//         Editor.removeMark(editor, format)
//     } else {
//         Editor.addMark(editor, format, true)
//     }
// }

const Element = ({ attributes, children, element }) => {
    // console.log(attributes)
    switch (element.type) {
        case 'block-quote':
            return <>
                <blockquote {...attributes}>{children}</blockquote>
                <Divider />
            </>

        case 'bulleted-list':
            return <ul {...attributes}>{children}</ul>
        case 'heading-one':
            return <h1 {...attributes}>{children}</h1>
        case 'heading-two':
            return <h2 {...attributes}>{children}</h2>
        case 'list-item':
            return <li {...attributes}>{children}</li>
        case 'numbered-list':
            return <ol {...attributes}>{children}</ol>
        case 'paragraphTitle':
            return <p {...attributes}>
                <strong>
                    {children}
                </strong>
            </p>
        default:
            return <p {...attributes}>{children}</p>
    }
}

const Leaf = ({ attributes, children, leaf }) => {
    // console.log(leaf.bold)

    if (leaf.bold) {
        children = <strong>{children}</strong>
    }

    if (leaf.italic) {
        children = <em>{children}</em>
    }

    if (leaf.align_center) {
        // children = <div style={{ textAlign: 'center' }}>{children}</div>
        children = <Typography align="center">{children}</Typography>
    }
    if (leaf.align_right) {
        // children = <div style={{ textAlign: 'right' }}>{children}</div>
        children = <Typography align="right">{children}</Typography>
    }
    if (leaf.align_left) {
        // children = <div style={{ textAlign: 'left' }}>{children}</div>
        children = <Typography align="left">{children}</Typography>
    }
    // if (leaf.underline) {
    //   children = <u>{children}</u>
    // }
    // if (leaf.code) {
    //   children = <code>{children}</code>
    // }

    return <span {...attributes}>{children}</span>
}


const initialValue: Descendant[] = [


    // {
    //     type: 'type',
    //     children: [
    //         { text: 'type: image', field: 'firstParagraph' },
    //     ],
    // },
    // {
    //     type: 'type',
    //     children: [
    //         { text: 'field: profileImage', field: 'firstParagraph' },
    //     ],
    // },

    // {
    //     type: 'type',
    //     children: [
    //         { text: 'style: fontsize: 15, marginleft: 10', field: 'firstParagraph' },
    //     ],
    // },

    // {
    //     type: 'type',
    //     children: [
    //         { text: 'align: center', field: 'firstParagraph' },
    //     ],
    // }


    // {
    //     type: 'type',
    //     children: [
    //         { text: 'type: image', field: 'firstParagraph' },
    //     ],
    // },

    // {
    //     type: 'type',
    //     children: [
    //         { text: 'field: profileImage', field: 'firstParagraph' },
    //     ],
    // },

    // {
    //     type: 'type',
    //     children: [
    //         { text: 'styles: fontSize: 15, marginLeft: 25, marginRight: 25', field: 'firstParagraph' },
    //     ],
    // },




    {
        type: 'type',
        children: [
            { text: '- type:', field: 'firstParagraph' },
        ],
    },

    {
        type: 'field',
        children: [
            { text: 'field:', field: 'firstParagraph' },
        ],
    },
    // {
    //     type: 'align',
    //     children: [
    //         { text: 'align:', field: 'firstParagraph' },
    //     ],
    // },

    // {
    //     type: 'text',
    //     children: [
    //         { text: 'text: ', field: 'firstParagraph' },
    //     ],
    // },

    // {
    //     type: 'icon',
    //     children: [
    //         { text: 'icon: ', field: 'firstParagraph' },
    //     ],
    // },
    // {
    //     type: 'link',
    //     children: [
    //         { text: 'link:', field: 'firstParagraph' },
    //     ],
    // },

    {
        type: 'style',
        children: [
            { text: 'style:', field: 'firstParagraph' },
        ],
    },







    // {
    //     type: 'type',
    //     children: [
    //         { text: 'align: center', field: 'firstParagraph' },
    //     ],
    // }










    // {
    //     type: 'field',
    //     children: [
    //         { text: 'bold aaa' },
    //         { text: '1111111111 2222222222 3333333333 4444444444' },
    //         { text: '5555555555 6666666666 7777777777 8888888888' }
    //     ],
    // },
    //     {
    //         type: 'paragraph',
    //         children: [
    //             { text: 'bold italic aaa', bold: true, italic: true },
    //             { text: '1111111111 2222222222 3333333333 4444444444 5555555555 6666666666 7777777777 8888888888', italic: true }
    //         ],
    //     },


    // {
    //     type: 'paragraph',
    //         children: [
    //             { text: 'aaa' }
    //         ],
    // },
    // {
    //     type: 'paragraph',
    //         children: [
    //             { text: 'CLINICAL INFORMATION:', bold: true }
    //         ],
    // },
    // {
    //     type: 'paragraph',
    //         children: [
    //             { text: 'FINAL DIAGNOSIS', bold: true },
    //         ],
    // },
    // {
    //     type: 'paragraph',
    //         children: [
    //             { text: 'MICROSCOPIC EXAM:', bold: true },
    //         ],
    // },
    // {
    //     type: 'paragraph',
    //         children: [
    //             { text: '' },
    //         ],
    // },

    // {
    //     type: 'paragraph',
    //         children: [
    //             { text: 'CONSULTATION SPECIMEN DESCRIPTION:', bold: true },
    //         ],
    // },
]

let slateGlobalValue: Descendant[];


// let el = Element({ attributes, children, element })




export default function SlateEditor(props: SlateEditorProps) {


    const renderElement = React.useCallback(props => <Element {...props} />, [])
    const renderLeaf = React.useCallback(props => <Leaf {...props} />, [])
    const [value, setValue] = React.useState(initialValue)
    // const [value, setValue] = React.useState<Descendant[] | null>(null)
    // const [value, setValue] = React.useState<Descendant[]>([{ "type": "paragraphTitle", "children": [{ "bold": true, "text": "start value" }] }])

    const editor = useMemo(() => withHistory(withReact(createEditor())), [])



    // React.useEffect(() => {
    //     const onMacrosInsert = (param) => {
    //         editor.insertText(param.text)
    //         //setText(text);
    //     }

    //     const onMacrosToggeMark = (param) => {
    //         console.log(`heey i am from slate Editor and just changed the mark to ${ param.mark }`)
    //         toggleMark(editor, param.mark)
    //         //setText(text);
    //     }

    //     GD.pubsub_.addListener(markSlateId, onMacrosToggeMark);
    //     GD.pubsub_.addListener(macroCopyInsertSlateId, onMacrosInsert);


    //     return () => GD.pubsub_.removeListener(macroCopyInsertSlateId, onMacrosInsert);
    // }, []);


    React.useEffect(() => {
        // getReport(props.scanId).then(d => {
        //     console.log(d)
        //     setValue(JSON.parse(d.text))
        // }).catch(err => console.log(err));
    }, [])


    if (!value) {
        console.log(`no value`)
        return <></>
    }

    let newTab: string[] = ['-type: \n', 'field: \n', 'align: \n', 'text: \n', 'icon: \n', 'link: \n', 'style: \n']

    return <Grid sx={{ position: 'relative' }} container columnSpacing={1}>
        <Grid item xs={12} >



            <Stack direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}>

                <Stack>
                    <Button variant="outlined" onMouseDown={e => {
                        e.preventDefault();
                        GD.pubsub_.dispatch(markSlateId, { mark: "Type" })
                    }}
                        onClick={() => {

                            // for(let newStructure of newTab) {
                            //         editor.insertNode(
                            //             {text: newStructure},
                            //         )
                            //     }
                            // editor.insertText('-type:')
                            // let image={}
                            // Transforms.insertNodes(editor, image)

                            // for(let item of initialValue){
                            //     console.log(item)
                            //     value.push(item)

                            // }

                            // let newValue = value.concat(initialValue)
                            // setValue(initialValue)
                            // console.log(newValue)
                            // console.log(value)

                            // console.log(Transforms.insertNodes(editor, initialValue));


                            // Transforms.setNodes(
                            //     editor,
                            //     {
                            //         field: 'firstName',
                            //     },
                            //     { at: [0] },
                            // )

                            for (const item of initialValue) {
                                console.log('item', item)
                                Transforms.insertNodes(editor, item, {
                                    at: [editor.children.length],
                                });

                            }
                            console.log(value)

                        }}
                    >Type</Button>
                </Stack>

                <Stack>
                    <Button variant="outlined" onMouseDown={e => {
                        e.preventDefault();
                        GD.pubsub_.dispatch(markSlateId, { mark: "Field" })
                    }}
                        onClick={() => {
                            // React.useEffect(() => {
                            editor.insertText('field:')
                            // })
                        }}
                    >Field</Button>
                </Stack>
                <Stack>
                    <Button variant="outlined" onMouseDown={e => {
                        e.preventDefault();
                        GD.pubsub_.dispatch(markSlateId, { mark: "Style" })
                    }}
                        onClick={() => {
                            // React.useEffect(() => {
                            editor.insertText('style:')
                            // })
                        }}
                    >Style</Button>
                </Stack>

                <Stack>
                    <Button variant="outlined" onMouseDown={e => {
                        e.preventDefault();
                        GD.pubsub_.dispatch(markSlateId, { mark: "Icon Image" })
                    }}
                        onClick={() => {
                            // React.useEffect(() => {
                            editor.insertText('asdasd')
                            // })
                        }}
                    >Icon Image</Button>
                </Stack>

                <Button
                    variant="contained"
                    size="large"
                    onClick={() => {
                        generateJsonFromSlate(value)
                    }}
                >Finalize</Button>
            </Stack>




            <Slate editor={editor}
                initialValue={value}
                onChange={value => {
                    // console.log(YAML.stringify(value))
                    slateGlobalValue = value;
                    setValue(value)
                }
                }>
                {/* <Editable renderElement={renderElement} /> */}

                <Editable
                    renderElement={renderElement}
                    renderLeaf={renderLeaf}
                    spellCheck
                    autoFocus
                    style={{
                        overflow: "auto",
                        height: '100%',
                        padding: '0 10px',
                        border: 'solid 1px gray'
                    }}
                />
            </Slate>
        </Grid>

    </Grid>


}


function generateJsonFromSlate(value: Descendant[]) {
    let newYamlObj: Record<any, any> = {};


    value.forEach((item) => {
        item['children'].forEach((obj) => {
            let keyValueArr = obj.text.split(':')
            console.log(keyValueArr)
            
            let key = keyValueArr[0].trim();
            console.log('kkaksdk', key)
            let value: Array<any> = [];
            let lastedValue: Array<string> = [];

            
            if (key === 'style') {
                for (let k = 1; k < keyValueArr.length; k++) {

                    // console.log('keyValueArr', keyValueArr)
                    // delete keyValueArr[0]
                    
                    // let b = keyValueArr.join(':')
                    // console.log('b',b)
                    // let n = b.split(',')
                    // console.log('n',n)

                    // value.push(n[k])
                    // console.log('keyValueArr[k]', n[k])
                    
                    value.push(keyValueArr[k].trim())
                    console.log('keyValueArr[k]', keyValueArr[k])
             

                }
                console.log('value1', value)
             
            }
            else {

             
                value.push(keyValueArr[1].trim());
                console.log('value2', value)
             
            }

            if (key === 'style') {
                console.log('value', value)
                let v = value.join(': ')
                console.log('v', v)
                let g = v.split(',')
                console.log('g', g)

                // let indexForDeleting = g.indexOf(':')
                // console.log('indexForDeleting', indexForDeleting)
                // for (let b = 0; b < indexForDeleting + 1; b++) {
                //     delete g[b];
                // }

                // let a = g.join('')
                console.log('obj.text', g)
                console.log('typeof a', typeof g)

                // let n = a.split(',')
                // value.push(g)

                for(let lastValue of g) {
                    lastedValue.push(lastValue.trim())
                }

                console.log('lastedValue', lastedValue)

                
                // console.log('lastValueOfStyles', value)

                console.log('styleValue', value)
                newYamlObj[key] = lastedValue


            }
            else {
                console.log('vvvvvvvvvvvalue', value)
                for (let lastValue of value) {
                    console.log('lastValue', lastValue)

                    newYamlObj[key] = lastValue
                }
            }


        })
    })
    const YAML = require('yaml');
    const doc = new YAML.Document();
    doc.contents = newYamlObj;
    console.log('newYamlObj', newYamlObj)
    console.log(doc.toString());
    let slateTemplate = doc.toString()
    saveReport(slateTemplate)
    return
}



function saveReport(slateTemplate) {
    // console.log(slateTemplate)
    if (slateTemplate) {
        // console.log(slateTemplate)
        Api.requestSession<any>('user', 'add_template', {}, slateTemplate).then(d => {
            alert(`Report ${slateTemplate} was saved`)
            console.log(d)
        }).catch(err => console.log(err));
    }
    return
}

// function SlateToolBar() {
//     const params = useParams();
//     // console.log(reportId)
//     return
// }
